export const FLOWER          = 'FLOWER';
export const PREROLL         = 'PREROLL';
export const INFUSED         = 'INFUSED';


// WEBPACK FOOTER //
// ./src/const/productConstants.js